export const actions = {
    GET_EXAM_SESSION_LIST: 'GET_EXAM_SESSION_LIST',
    SET_EXAM_SESSION_LIST: 'SET_EXAM_SESSION_LIST',
    GET_EXAM_SESSION_SELECTED: 'GET_EXAM_SESSION_SELECTED',
    SET_EXAM_SESSION_SELECTED: 'SET_EXAM_SESSION_SELECTED',
    GET_EXAM_SESSION_ADD: 'GET_EXAM_SESSION_ADD',
    GET_EXAM_SESSION_UPDATE: 'GET_EXAM_SESSION_UPDATE',
    SET_EXAM_SESSION_UPDATE: 'SET_EXAM_SESSION_UPDATE',
    SET_EXAM_SESSION_UPDATE_DEFAULT: 'SET_EXAM_SESSION_UPDATE_DEFAULT',
    SET_EXAM_SESSION_LIST_DEFAULT: 'SET_EXAM_SESSION_LIST_DEFAULT',

    GET_EXAM_SESSION_ADD_QUESTION_LIST: 'GET_EXAM_SESSION_ADD_QUESTION_LIST',
    GET_EXAM_SESSION_ADD_QUESTION_LIST_DEFAULT: 'GET_EXAM_SESSION_ADD_QUESTION_LIST_DEFAULT',
    SET_EXAM_SESSION_ADD_QUESTION_LIST: 'SET_EXAM_SESSION_ADD_QUESTION_LIST',

    GET_EXAM_SESSION_ADD_QUESTION: 'GET_EXAM_SESSION_ADD_QUESTION',
    GET_EXAM_SESSION_DELETE_QUESTION: 'GET_EXAM_SESSION_DELETE_QUESTION',

    GET_EXAM_SESSION_QUESTION_LIST: 'GET_EXAM_SESSION_QUESTION_LIST',
    SET_EXAM_SESSION_QUESTION_LIST: 'SET_EXAM_SESSION_QUESTION_LIST',

    GET_EXAM_SESSION_ADD_STUDENT_LIST: 'GET_EXAM_SESSION_ADD_STUDENT_LIST',
    GET_EXAM_SESSION_ADD_STUDENT_LIST_DEFAULT: 'GET_EXAM_SESSION_ADD_STUDENT_LIST_DEFAULT',
    SET_EXAM_SESSION_ADD_STUDENT_LIST: 'SET_EXAM_SESSION_ADD_STUDENT_LIST',

    GET_EXAM_SESSION_ADD_STUDENT: 'GET_EXAM_SESSION_ADD_STUDENT',
    GET_EXAM_SESSION_DELETE_STUDENT: 'GET_EXAM_SESSION_DELETE_STUDENT',

    GET_EXAM_SESSION_STUDENT_LIST: 'GET_EXAM_SESSION_STUDENT_LIST',
    SET_EXAM_SESSION_STUDENT_LIST: 'SET_EXAM_SESSION_STUDENT_LIST',

    GET_EXAM_SESSION_PUBLISH_DATAS: 'GET_EXAM_SESSION_PUBLISH_DATAS',
    SET_EXAM_SESSION_PUBLISH_DATAS: 'SET_EXAM_SESSION_PUBLISH_DATAS',

    GET_EXAM_SESSION_PUBLISH: 'GET_EXAM_SESSION_PUBLISH',
    GET_EXAM_SESSION_UNPUBLISH: 'GET_EXAM_SESSION_UNPUBLISH',


    GET_EXAM_SESSION_STUDENT_CHECK_LIST: 'GET_EXAM_SESSION_STUDENT_CHECK_LIST',
    GET_EXAM_SESSION_STUDENT_CHECK_LIST_DATAS: 'GET_EXAM_SESSION_STUDENT_CHECK_LIST_DATAS',

};